"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSticky = void 0;
const react_1 = __importDefault(require("react"));
const ramda_1 = __importDefault(require("ramda"));
const style_1 = __importDefault(require("style"));
var StickyState;
(function (StickyState) {
    StickyState["Leaving"] = "leaving";
    StickyState["None"] = "none";
    StickyState["Sticky"] = "sticky";
})(StickyState || (StickyState = {}));
function toStickyState({ element, scrollY, start, }) {
    const startY = start.current.offsetTop;
    const endY = startY + start.current.offsetHeight;
    const endElementY = endY - element.current.clientHeight;
    if (scrollY > startY &&
        scrollY < endElementY) {
        return StickyState.Sticky;
    }
    else if (scrollY > startY &&
        scrollY < endY) {
        return StickyState.Leaving;
    }
    return StickyState.None;
}
function applyStyles(styles, element) {
    return ramda_1.default.reduce((acc, [key, value]) => {
        const current = element.style[key];
        element.style[key] = value;
        return ramda_1.default.set(ramda_1.default.lensProp(key), current, acc);
    }, {}, ramda_1.default.toPairs(styles));
}
/**
 * Create a sticky element.
 */
function useSticky() {
    const element = react_1.default.useRef();
    const start = react_1.default.useRef();
    const [state, setState] = react_1.default.useState(StickyState.None);
    const [previousStyles, setPreviousStyles] = react_1.default.useState({});
    const [placeholder, setPlaceholder] = react_1.default.useState();
    react_1.default.useEffect(() => {
        function onScroll(event) {
            const next = toStickyState({
                element,
                start,
                scrollY: window.scrollY,
            });
            if (next === StickyState.Leaving) {
                const bound = start.current.getBoundingClientRect();
                const dork = bound.y + bound.height;
                const zoom = dork - element.current.clientHeight;
                const startY = start.current.offsetTop;
                const endY = startY + start.current.offsetHeight;
                const diff = (window.scrollY - start.current.offsetHeight);
                applyStyles({
                    top: `${zoom}px`,
                }, element.current);
            }
            setState(next);
        }
        document.addEventListener('scroll', onScroll);
        return () => {
            document.removeEventListener('scroll', onScroll);
        };
    }, []);
    react_1.default.useEffect(() => {
        if (state === StickyState.Sticky) {
            // Create a clone and place it next to the current element.
            const clone = element.current.cloneNode(true);
            element.current.after(clone);
            clone.style.visibility = 'hidden';
            setPlaceholder(clone);
            const elementBoundingRect = element.current.getBoundingClientRect();
            const previous = applyStyles({
                left: elementBoundingRect.left,
                position: 'fixed',
                top: 0,
                width: `${elementBoundingRect.width}px`,
                zIndex: style_1.default.Depth.Position.F100,
            }, element.current);
            setPreviousStyles(previous);
        }
        else if (state === StickyState.None) {
            applyStyles(previousStyles, element.current);
            if (placeholder) {
                placeholder.remove();
            }
        }
    }, [state]);
    return { element, start };
}
exports.useSticky = useSticky;
